var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCombinedIcon = function SvgCombinedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17.5000001px",
    height: "17.5000001px",
    viewBox: "0 0 17.5000001 17.5000001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.17.0-Setup-/-Company-/-Create-new-project-/-Step-1---default",
    transform: "translate(-1387.250000, -577.250000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-all-doc-/-Lifestyle-survey",
    transform: "translate(672.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/03.Input-&-Dropdown/01.Without-discription-Copy-9",
    transform: "translate(392.000000, 538.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.Molecules/07.Input/01.Text/Default",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(320.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8142781,3.24999996 C16.3647648,3.25441357 17.6205864,4.51023523 17.6249975,6.06072187 L17.618,6.37499996 L17.8984375,6.37499997 C19.4170665,6.37499997 20.6584277,7.56212442 20.7451593,9.05901153 L20.75,9.22656249 L20.75,17.8984375 C20.75,19.473312 19.473312,20.75 17.8984375,20.75 L9.22656249,20.75 C7.651688,20.75 6.37499997,19.473312 6.37499997,17.8984375 L6.37499996,17.625 L6.06072187,17.625 C4.51023523,17.6205864 3.25441357,16.3647648 3.24999996,14.8125 L3.24999996,6.37315273 C3.25509447,4.65039808 4.65039808,3.25509447 6.37499997,3.24999996 L14.8142781,3.24999996 Z M17.8984375,7.62499998 L9.22656249,7.62499998 C8.34204394,7.62499998 7.62499998,8.34204394 7.62499998,9.22656249 L7.62499998,17.8984375 C7.62499998,18.7829561 8.34204394,19.5 9.22656249,19.5 L17.8984375,19.5 C18.7829561,19.5 19.5,18.7829561 19.5,17.8984375 L19.5,9.22656249 C19.5,8.34204394 18.7829561,7.62499998 17.8984375,7.62499998 Z M14.8125,4.49999996 L6.37684722,4.49999723 C5.34156169,4.50305713 4.50305713,5.34156169 4.49999996,6.37499997 L4.49999743,14.8107219 C4.50245238,15.6736313 5.20136865,16.3725476 6.06249997,16.375 L6.37499996,16.375 L6.37499997,9.22656249 C6.37499997,7.70793351 7.56212442,6.46657231 9.05901153,6.37984068 L9.22656249,6.37499997 L16.368,6.37499996 L16.3749219,6.05843747 L16.3747205,6.03844052 C16.3587164,5.19605573 15.6789617,4.51628382 14.8382848,4.50028194 L14.8125,4.49999996 Z",
    id: "Combined-Shape"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCombinedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/combined-icon.95c17551.svg";
export { ForwardRef as ReactComponent };